<template>
  <div>
    <div id="landing-container" class="container-fluid" :style="{ backgroundImage: `url('${require('../assets/images/landing-background.jpg')}')` }">
      <div id="landing" class="container container-onepage">
        <div class="row">
          <div class="col-md-12 col">
            <div class="row-aligned-content">
              <img src="../assets/images/giz.svg" width="25%">
              <h2>Zusatzmaterialien</h2>
              <p>Hier können Sie Zusatzmaterial kostenfrei <router-link to="/resources">herunterladen.</router-link></p>
              <p>
                Das Projekt Kontrastive Alphabetisierung im Situationsansatz (KASA) ist
                seit dem 31.7.2022 beendet. Diese Homepage wird nicht weiter gepflegt.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    data () {
      return {}
    }
  }
</script>


<style lang="scss" scoped>
  @import '../style/bootstrap-component-include';

  .container-onepage {
    height: calc(100vh - 55px);
    display: table;
  }

  .container-onepage .row {
    display: table-row;

    .col {
      display: table-cell;
      vertical-align: middle;
      min-height: 0;
      .row-aligned-content {

        text-align: center;

        img {
          margin-bottom: 20px;
          max-width: 80%;
        }
      }
    }
  }

  #landing {
    background-color: rgba(255, 255, 255, 0.8);
  }

  #landing-container {
    background-size: cover;
    margin-bottom: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue